// extracted by mini-css-extract-plugin
module.exports = {"row-center":"_1CKvLlqrN2Nv0o0Itm4hhw","activate":"_128NACITdWSEzVzIoR3Gin","link":"_2_65xhlA14FMkflp-waVHR"};